module.exports = __webpack_public_path__ + "img/RORBPJR40043.009eaf0d.png";